import { createContext } from 'react';
const ReadContext = createContext();
export default ReadContext;
